import { PREDICTIONS_STEPS_ORDER } from '../../constants';

const isNextStep = (newStep, currentStep) =>
  PREDICTIONS_STEPS_ORDER.findIndex((el) => el === newStep) >
  PREDICTIONS_STEPS_ORDER.findIndex((el) => el === currentStep);

export default isNextStep;
